import { Pipe, type PipeTransform } from '@angular/core';
import type { UserContact } from '@shared/models/user';

export type NameFormat = 'initials' | 'full';

@Pipe({
  name: 'name',
})
export class NamePipe implements PipeTransform {
  transform(
    user: UserContact | undefined | null,
    format: NameFormat = 'full',
  ): string {
    return formatName(user, format);
  }
}

export const formatName = (
  user: UserContact | undefined | null,
  format: NameFormat = 'full',
): string => {
  if (!user) return '';

  const first = user.firstname ?? '';
  const last = user.lastname ?? '';
  const displayName = user.displayName;

  if (format === 'initials') {
    if (displayName) {
      return displayName.charAt(0).toUpperCase();
    }
    return `${first.charAt(0).toUpperCase()}${last.charAt(0).toUpperCase()}`;
  }
  return displayName || `${first} ${last}`;
};
